import { render, staticRenderFns } from "./ChatIconText.vue?vue&type=template&id=e4ecaa4c"
import script from "./ChatIconText.vue?vue&type=script&lang=js"
export * from "./ChatIconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports